import React, { useEffect, useState } from 'react';
import LampIcon from './LampIcon';
import config from '../config';
import './Confirmation.css';

export default function Confirmation({ submitterName }) {
  const [visible, setVisible] = useState(false);
  const firstName = (submitterName || '').split(' ')[0] || 'there';

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`confirmation ${visible ? 'confirmation--visible' : ''}`}>
      {/* Animated checkmark ring */}
      <div className="confirmation__ring">
        <svg className="confirmation__ring-svg" viewBox="0 0 80 80">
          <circle
            className="confirmation__ring-track"
            cx="40" cy="40" r="34"
            strokeWidth="1.5"
            fill="none"
          />
          <circle
            className="confirmation__ring-progress"
            cx="40" cy="40" r="34"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
          />
          <path
            className="confirmation__check"
            d="M 26 40 L 36 50 L 54 30"
            fill="none"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h2 className="confirmation__heading">
        Your wish is<br />captured, {firstName}.
      </h2>

      <p className="confirmation__body">
        We'll sketch the AI agent we'd build for your problem and send it to your inbox
        a week from today — a one-page concept, made for you.
      </p>

      <div className="confirmation__divider">
        <LampIcon size={22} color="rgba(174,150,72,0.5)" />
      </div>

      <p className="confirmation__print-offer">
        Want the full A4 print version mailed to your office?
        Reply to the email with your office address — we'll send it hand-signed in metallic gold ink.
      </p>

      <div className="confirmation__signoff">— {config.SIGNOFF}</div>
    </div>
  );
}
